// ===================================================================
// KAIXO - langCode helper
// ===================================================================
// Convierte el idioma KAIXO ('español', 'inglés', etc.) al código ISO
// 639-1 estándar ('es', 'en', ...) que esperan navegadores/plugins:
//   - <input lang="..."> para el corrector ortográfico nativo
//   - <html lang="..."> para SEO/screen readers
//   - libs de i18n
// ===================================================================

const KAIXO_TO_ISO = {
    'español': 'es', 'inglés': 'en', 'francés': 'fr', 'alemán': 'de',
    'portugués': 'pt', 'italiano': 'it', 'euskera': 'eu',
    'chino': 'zh', 'japonés': 'ja', 'árabe': 'ar', 'hindi': 'hi',
    'ruso': 'ru', 'coreano': 'ko', 'turco': 'tr', 'indonesio': 'id',
    // Variantes en inglés por si llega ya traducido
    'english': 'en', 'spanish': 'es', 'french': 'fr', 'german': 'de',
    'portuguese': 'pt', 'italian': 'it', 'basque': 'eu',
    'chinese': 'zh', 'japanese': 'ja', 'arabic': 'ar', 'russian': 'ru',
    'korean': 'ko', 'turkish': 'tr', 'indonesian': 'id'
};

export function langToISO(language) {
    if (!language) return 'en';
    const k = String(language).toLowerCase().trim();
    return KAIXO_TO_ISO[k] || 'en';
}

// Mapeo a códigos BCP-47 — el formato que esperan los motores de TTS
// (web SpeechSynthesis y Capacitor). Útil para escoger la voz correcta.
// 'euskera' → 'es-ES' como fallback porque la mayoría de motores TTS
// no tienen voz nativa de euskera; el español se le aproxima fonéticamente.
const KAIXO_TO_BCP47 = {
    'español': 'es-ES', 'inglés': 'en-US', 'francés': 'fr-FR',
    'alemán': 'de-DE', 'portugués': 'pt-BR', 'italiano': 'it-IT',
    'euskera': 'es-ES', 'chino': 'zh-CN', 'japonés': 'ja-JP',
    'árabe': 'ar-SA', 'hindi': 'hi-IN', 'ruso': 'ru-RU',
    'coreano': 'ko-KR', 'turco': 'tr-TR', 'indonesio': 'id-ID',
    'english': 'en-US', 'spanish': 'es-ES', 'french': 'fr-FR',
    'german': 'de-DE', 'portuguese': 'pt-BR', 'italian': 'it-IT',
    'basque': 'es-ES', 'chinese': 'zh-CN', 'japanese': 'ja-JP',
    'arabic': 'ar-SA', 'russian': 'ru-RU', 'korean': 'ko-KR',
    'turkish': 'tr-TR', 'indonesian': 'id-ID'
};

export function langToBCP47(language) {
    if (!language) return 'en-US';
    const k = String(language).toLowerCase().trim();
    return KAIXO_TO_BCP47[k] || 'en-US';
}

// Lista canónica de idiomas KAIXO con su nombre nativo (para selectores
// donde el usuario tiene que reconocerlo "como suena en su idioma").
// Sirve también como única fuente de verdad de los 15 idiomas soportados.
export const KAIXO_LANGUAGES = [
    { key: 'español',    label: 'Español',    iso: 'es' },
    { key: 'inglés',     label: 'English',    iso: 'en' },
    { key: 'francés',    label: 'Français',   iso: 'fr' },
    { key: 'alemán',     label: 'Deutsch',    iso: 'de' },
    { key: 'portugués',  label: 'Português',  iso: 'pt' },
    { key: 'italiano',   label: 'Italiano',   iso: 'it' },
    { key: 'euskera',    label: 'Euskara',    iso: 'eu' },
    { key: 'chino',      label: '中文',        iso: 'zh' },
    { key: 'japonés',    label: '日本語',      iso: 'ja' },
    { key: 'árabe',      label: 'العربية',     iso: 'ar' },
    { key: 'hindi',      label: 'हिन्दी',        iso: 'hi' },
    { key: 'ruso',       label: 'Русский',    iso: 'ru' },
    { key: 'coreano',    label: '한국어',       iso: 'ko' },
    { key: 'turco',      label: 'Türkçe',     iso: 'tr' },
    { key: 'indonesio',  label: 'Bahasa Indonesia', iso: 'id' }
];
